import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ca78dae")

_pushScopeId("data-v-6ca78dae")
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { id: "alert-message-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheEventListItem = _resolveComponent("TheEventListItem")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("p", _hoisted_1, "Seznam promo akcí (" + _toDisplayString(_ctx.promoEvents.length) + ")", 1),
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.promoEvents, (promoEvent) => {
        return (_openBlock(), _createBlock("li", {
          key: promoEvent.id
        }, [
          _createVNode(_component_TheEventListItem, {
            "promo-event": promoEvent,
            "is-rearranging": _ctx.isRearranging,
            "list-length": _ctx.promoEvents.length,
            onMovePromoEvent: _ctx.movePromoEvent,
            onRemovePromoEvent: _ctx.removePromoEventFromList,
            onEditPromoEvent: _ctx.editPromoEvent,
            onInvokeError: _ctx.invokeError,
            onInvokeSuccess: _ctx.invokeSuccess
          }, null, 8, ["promo-event", "is-rearranging", "list-length", "onMovePromoEvent", "onRemovePromoEvent", "onEditPromoEvent", "onInvokeError", "onInvokeSuccess"])
        ]))
      }), 128))
    ])
  ], 64))
})